<template>
    <div class="template">
        <div class="tempRight">
            <div class="tempTitle">
                <div class="left">自建模板列表</div>
                <div class="add" @click="handlCheckAdd">新增模板</div>
                <input type="file" id="fileExport" @change="handleFileChange" ref="inputer" style="display: none;">
                <div class="right">
                    <el-input placeholder="请输入合同标题" v-model="title" clearable @change="handlSearch"></el-input>
                    <div class="btn" @click="handlSearch">搜索</div>
                </div>
            </div>
            <div class="temp_for">
                <div class="conTemp" v-for="(item,index) in tempData" :key="index" @mouseenter="enters(item)"
                     @mouseleave="leaver(item)">
                    <div class="contract">
                        <img :src="item.url"/>
                        <div class="contractHover" v-show="item.isZhe"></div>
<!--                        <div class="dele" @click="handlDele(item)">-->
<!--                            <img class="img1" src="../../../../static/img/dele.png"/>-->
<!--                        </div>-->
                    </div>
                    <div class="title" :class="item.isZhe ? 'titleHover' : ''">{{item.title}}</div>
                    <div class="con_btn">
                        <div class="btn" @click="handlCheckTemp(item,0)">编辑使用</div>
                        <div class="btn" @click="handlDele(item)">删除</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                btnActive: false,
                tempData: [],
                title: ''
            }
        },
        mounted() {
            let params = new FormData();
            params.append('token', this.$global.token);
            params.append('type', '1');
            this.getData(params);
        },
        methods: {
            handlDele(item) {
                let _this = this;
                _this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let formData = new FormData();
                    formData.append('templateId', item.id);
                    _this.api.delTemplate(formData).then(res => {
                        console.log(res)
                        _this.$message.success('删除成功');
                        let params = new FormData();
                        params.append('token', _this.$global.token);
                        params.append('type', '1');
                        _this.getData(params);
                    })
                }).catch(() => {
                });


            },
            handlSearch() {
                let params = new FormData();
                params.append('token', this.$global.token);
                params.append('type', 1);
                params.append('title', this.title);
                this.getData(params);
            },
            enters(item) {
                item.isZhe = true;
            },
            leaver(item) {
                item.isZhe = false;
            },
            handlCheckTemp(item, index) {
                if (index == 1) {
                    this.$router.push({
                        name: 'detalContract',
                        params: {
                            id: item.id,
                            title: item.title,
                            isMy: 0,
                            isLook: 1
                        }
                    })
                } else {
                    console.log( item )
                    if( item.type=='2'){


                        this.$router.push({
                            name: 'templateDetailPdf',
                            params: {
                                id: item.id,
                                title: item.title,
                                isMy: 0,
                                isLook: 0,
                                type: item.type ,
                                pdfPath: item.path
                            }
                        })

                    }else{

                        this.$router.push({
                            name: 'detalContract',
                            params: {
                                id: item.id,
                                title: item.title,
                                isMy: 0,
                                isLook: 0,
                                type: item.type ,
                            }
                        })

                    }


                }

            },
            handlCheckAdd() {
                this.$refs.inputer.click();
            },
            handleFileChange(e) {
                let inputDOM = this.$refs.inputer;
                let file = inputDOM.files[0];
                console.log(file);

                let supports = [
                    'pdf',
                    'doc',
                    'docx',
                    // 'xls',
                    // 'xlsx',
                ];
                /* 限制文件上传类型 docx */
                let suffixName = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
                if (supports.indexOf(suffixName) === -1) {
                    this.$message.warning("支持上传pdf,doc,docx格式文件!");
                    return;
                }

                /* 限制文件上传大小 */
                let isLtSize = file.size / 1024 / 1024 < 100;
                if (!isLtSize) {
                    this.$message.warning("上传文件不能超过 100MB!");
                    return;
                }

                let fromData = new FormData();
                fromData.append('token', this.$global.token)
                fromData.append('file', file)

                e.target.value = '';
                this.getContractTemp(fromData);
            },
            getContractTemp(params) {
                console.log(params);
                let _this = this;
                _this.api.addTemplateInfo(params).then(res => {
                    console.log( res);
                    if( res.code!=0 ){
                        _this.$message.error( res.data.msg);
                    }else{

                        _this.$message.success("新增成功");
                        let formData = new FormData();
                        formData.append('token', _this.$global.token);
                        formData.append('type', '1');
                        _this.getData(formData);
                    }
                })
            },
            getData(params) {
                let _this = this;

                _this.api.getTemplateList(params).then(res => {
                    console.log(res);
                    for (let i = 0; i < res.data.length; i++) {
                        res.data[i].isZhe = false;
                        res.data[i].url = require('../../../../static/img/contar-1.png');
                    }
                    _this.tempData = res.data;
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .template {
        width: @a;
        height: auto;

        .tempRight {
            width: @a;
            height: auto;
            padding-left: 4%;

            .tempTitle {
                width: auto;
                height: 40px;
                display: @flex;
                align-items: center;

                .add {
                    width: 120px;
                    height: 40px;
                    background-color: #f2f2f2;
                    border: solid 1px #aaaaaa;
                    text-align: center;
                    line-height: 40px;
                    margin-left: 33px;
                    font-size: 17px;
                    cursor: pointer;
                }

                .left {
                    width: 160px;
                    height: 40px;
                    line-height: 40px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                }

                .right {
                    width: 370px;
                    height: 40px;
                    display: @flex;
                    justify-content: flex-end;
                    margin-left: 400px;

                    .btn {
                        width: 80px;
                        height: 40px;
                        background-color: #f5f5f5;
                        border: solid 1px #aaaaaa;
                        letter-spacing: 1px;
                        color: #333333;
                        font-size: 16px;
                        line-height: 40px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }

            .temp_for {
                width: @a;
                height: auto;

                // overflow: hidden;
                .conTemp:first-child {
                    margin-left: 0;
                }

                .conTemp:nth-child(4n + 1) {
                    margin-left: 0;
                }

                .conTemp {
                    width: 245px;
                    height: 420px;
                    display: inline-block;
                    position: relative;
                    margin: 31px 0 0 33px;

                    .contractHover {
                        width: 245px;
                        height: 340px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#ffffff,
                        #ffffff);
                        background-blend-mode: normal,
                        normal;
                        opacity: 0.4;
                    }

                    .dele {
                        position: absolute;
                        right: 0;
                        top: 0;
                        width: 30px;
                        height: 30px;
                        cursor: pointer;
                        @row();

                        .img1 {
                            width: 20px;
                            height: 20px;
                            object-fit: cover;
                        }
                    }

                    .contract {
                        width: 245px;
                        height: 340px;
                        background-color: #ffffff;
                        border: solid 1px #aaaaaa;

                        img {
                            width: @a;
                            height: @a;
                            object-fit: cover;
                        }
                    }

                    .titleHover {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#f5f5f5,
                        #f5f5f5);
                        background-blend-mode: normal,
                        normal;
                        color: #fff !important;
                    }

                    .title {
                        width: 245px;
                        height: 46px;
                        background-color: #f5f5f5;
                        border: solid 1px #aaaaaa;
                        border-top: 0;
                        text-align: center;
                        line-height: 46px;
                        letter-spacing: 1px;
                        color: #333333;
                        font-size: 18px;

                        white-space: nowrap;

                        overflow: hidden;

                        text-overflow: ellipsis;
                        padding: 0 5px;
                    }


                    .con_btn {
                        width: 245px;
                        height: 30px;
                        margin-top: 5px;
                        display: @flex;
                        justify-content: space-between;

                        .btn:active {
                            background-image: linear-gradient(270deg,
                            #1e6eee 0%,
                            #109ee7 50%,
                            #01cee0 100%),
                            linear-gradient(#000000,
                            #000000);
                            background-blend-mode: normal,
                            normal;
                            color: #fff;
                        }

                        .btn {
                            width: 48%;
                            height: 30px;
                            text-align: center;
                            line-height: 30px;
                            background-color: #f2f2f2;
                            border: solid 1px #aaaaaa;
                            letter-spacing: 1px;
                            color: #333333;
                            font-size: 14px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/contract/me_template.vue